import * as angular from "angular";
import {PlayParticipantsProvider} from "./providers/PlayParticipantsProvider";
import {ngCache} from "ng-cache";
import {ParticipantController} from "./components/Participant";
import {ParticipantsContestantLinkController} from "./components/ParticipantsContestantLink";
import {ParticipantsControlsController} from "./components/ParticipantsControls";
import {component} from "./decorators/Component";
import {ParticipantsListContainerController} from "./components/ParticipantsListContainer";
import {ParticipantStateToggleController} from "./components/ParticipantStateToggle";
import {PlayParticipantsContainerController} from "./components/PlayParticipantsContainer";
import {RegionFilterController} from "./components/RegionFilter";
import {ToggleButtonController} from "./components/ToggleButton";
import {ParticipantsListController} from "./components/ParticipantsList";

export let playParticipants: angular.IModule = angular.module("playParticipants", [
    "playPagination",
    ngCache.name,
    "pascalprecht.translate"
]);

playParticipants.provider("PlayParticipants", PlayParticipantsProvider.instance);

playParticipants.run(["$rootScope", "PlayParticipants", function($rootScope, PlayParticipants) {
    $rootScope.PlayParticipants = PlayParticipants;
}]);

playParticipants.config(["$translateProvider", function ($translateProvider) {
    $translateProvider.translations("en", {
        "play-participants:status-seed": "Seed #{{ seed }}",
        "play-participants:status-no-seed": "In the " +
            "{{ leagueType == 'cup' ? 'Cup' : '' }} {{ leagueType == 'ladder' ? 'Ladder' : '' }} " +
            "{{ leagueType == 'swiss' ? 'Swiss Cup' : '' }} {{ leagueType == 'premiership' ? 'Premiership' : '' }} " +
            "{{ leagueType == 'eas2' ? 'A-Series' : '' }}",
        "play-participants:status-not-checked-in": "Not checked in",
        "play-participants:status-pending": "Signup pending",
        "play-participants:status-filter-pre-check-in": "Only show signed up {{ team ? 'teams' : 'players' }} in the " +
            "{{ leagueType == 'cup' ? 'Cup' : '' }} {{ leagueType == 'ladder' ? 'Ladder' : '' }} " +
            "{{ leagueType == 'swiss' ? 'Swiss Cup' : '' }} {{ leagueType == 'premiership' ? 'Premiership' : '' }} " +
            "{{ leagueType == 'eas2' ? 'A-Series' : '' }}",
        "play-participants:status-filter-post-check-in": "Only show checked in {{ team ? 'teams' : 'players' }}",
        "play-participants:sort-by": "Sort by",
        "play-participants:filter-by": "Country",
        "play-participants:search-participants": "Search {{ team ? 'teams' : 'players' }}",
        "play-participants:search-placeholder": "Enter {{ team ? 'team' : 'player' }} name",
        "play-participants:clear-filters": "Clear all filters",
        "play-participants:name": "Name",
        "play-participants:seed": "Seed",
        "play-participants:all-countries": "All",
        "play-participants:no-participants": "There are no contestants signed up for this league.",
        "play-participants:no-participants-filter": "No contestants found matching your filter criteria."
    });
}]);

playParticipants.config(["$httpProvider", "$compileProvider", (
    $httpProvider: angular.IHttpProvider,
    $compileProvider: angular.ICompileProvider
) => {
    $httpProvider.useApplyAsync(true);
    $compileProvider.debugInfoEnabled(false);
}]);

playParticipants.component("participant", component({
    bindings: {
        participant: "<",
        league: "<",
    },
    templateCacheUrl: "participants/participant.html",
    controllerAs: "ctrl",
    controller: ParticipantController
}));

playParticipants.component("participantsContestantLink", component({
    bindings: {
        contestant: "<",
        league: "<"
    },
    templateCacheUrl: "participants/contestant-link.html",
    controllerAs: "ctrl",
    transclude: true,
    controller: ParticipantsContestantLinkController
}));

playParticipants.component("participantsControls", component({
    bindings: {
        participants: "<",
        league: "<",
        sorting: "<",
        filtering: "<"
    },
    require: {
        app: "^playParticipantsContainer"
    },
    templateCacheUrl: "participants/participants-controls.html",
    controllerAs: "ctrl",
    controller: ParticipantsControlsController
}));

playParticipants.component("participantsList", component({
    bindings: {
        participants: "<",
        league: "<",
    },
    templateCacheUrl: "participants/participants-list.html",
    controllerAs: "ctrl",
    controller: ParticipantsListController
}));

playParticipants.component("participantsListContainer", component({
    bindings: {
        league: "<",
        participants: "<",
        sorting: "<",
        filtering: "<"
    },
    templateCacheUrl: "participants/participants-list-container.html",
    controllerAs: "ctrl",
    controller: ParticipantsListContainerController
}));

playParticipants.component("participantStateToggle", component({
    bindings: {
        league: "<",
        filtering: "<"
    },
    require: {
        app: "^playParticipantsContainer"
    },
    templateCacheUrl: "participants/participant-state-toggle.html",
    controllerAs: "ctrl",
    controller: ParticipantStateToggleController
}));

playParticipants.component("playParticipantsContainer", component({
    bindings: {
        leagueId: "<"
    },
    templateCacheUrl: "participants/play-participants-container.html",
    controllerAs: "ctrl",
    controller: PlayParticipantsContainerController
}));

playParticipants.component("regionFilter", component({
    bindings: {
        participants: "<",
        filtering: "<"
    },
    require: {
        app: "^playParticipantsContainer"
    },
    templateCacheUrl: "participants/region-filter.html",
    controllerAs: "ctrl",
    controller: RegionFilterController
}));

playParticipants.component("toggleButton", component({
    bindings: {
        sorting: "<",
        type: "<",
    },
    require: {
        app: "^playParticipantsContainer"
    },
    transclude: true,
    templateCacheUrl: "participants/toggle-button.html",
    controllerAs: "ctrl",
    controller: ToggleButtonController
}));

playParticipants.directive("onLoad", ["$parse", function ($parse) {
    return {
        restrict: "A",
        link: function (scope, elem, attrs) {
            let fn = $parse(attrs.onLoad);
            elem.on("load", function (event) {
                scope.$apply(function () {
                    fn(scope, { $event: event });
                });
            });
        }
    };
}]);